// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"emptyStateWarning_wrapper__1mwYC","hero-icon":"emptyStateWarning_hero-icon__2Vktg","small":"emptyStateWarning_small__2hVaF"};